import { cn } from '@goaltree/ui/lib/utils'
import { useTranslation } from 'react-i18next'

// Private to the coaching relationship: never render on social surfaces.
export function RolePill({ role, className }: { role: 'coach' | 'client'; className?: string }) {
  const { t } = useTranslation()
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full px-1.5 py-px text-[10.5px] leading-4 font-semibold whitespace-nowrap',
        role === 'coach' ? 'bg-coach/12 text-coach-text' : 'bg-muted text-muted-foreground',
        className,
      )}
    >
      {t(`coaching.role.${role}`)}
    </span>
  )
}
